import statuses from 'statuses';
/**
 * @ngdoc service
 * @name authInterceptor
 * @description
 * The `$http` interceptor that detects and invalid session and kicks the user out of the app.
 *
 * @memberof account
 */
class AuthInterceptor {
  /**
   * Class constructor.
   * @param {Service} $location   To redirect the user to the login or logout screen.
   * @param {Service} $q          To access already resolved/rejected promises.
   * @ignore
   */
  constructor(
    $location,
    $q,
  ) {
    'ngInject';

    /**
     * The local reference to the `$location` service.
     * @type {Object}
     */
    this.$location = $location;
    /**
     * The local reference to the `$q` service.
     * @type {Object}
     */
    this.$q = $q;
    /**
     * @ignore
     */
    this.response = this.response.bind(this);
    /**
     * @ignore
     */
    this.responseError = this.responseError.bind(this);
  }
  /**
   * This method gets executed after every successfully request and validates the "inner status"
   * of the response in order to validate if the user needs to be kicked out.
   * The reason of this "hack" is that the Photorank OAuth server returns some errors with an
   * http status of `200`, while its metadata says different.
   * @param {Object} response The request response.
   * @return {Object|Promise} If everythig is fine, return the response, otherwise, return a call
   *                          to `responseError`
   */
  response(response) {
    let result = response;
    if (response.data &&
            response.data.metadata &&
            response.data.metadata.code &&
            response.data.metadata.code >= statuses['bad request']
    ) {
      response.status = response.data.metadata.code;
      result = this.responseError(response);
    }

    return result;
  }
  /**
   * This method gets executed after a failed request,it redirects the user to the logout URL.
   * @param {Object} response The request response.
   * @return {Promise} an already rejected promise.
   */
  responseError(response) {
    if (response.status === statuses.unauthorized && !this.$location.path().includes('/login')) {
      this.$location.url('/logout');
    }

    return this.$q.reject(response);
  }
}

export default AuthInterceptor;



// WEBPACK FOOTER //
// ./src/frontend/modules/account/services/authInterceptor.js